import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper, faXmark } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { format, utcToZonedTime } from "date-fns-tz";
import ReservationItems from "./Reservations/ReservationItems";
import { DefaultDateSmallMins } from "./DefaultImports";

// Colors
const COLOR_ORANGE = "#EE754C";
const COLOR_GRAY = "#99B0AD";

const Modal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 520px;
  height: 70%;
  background: #fff;
  border-radius: 7px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;

const ModalHeader = styled.div`
  background: ${COLOR_GRAY};
  color: #faf6e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 18px;
  font-weight: bold;
`;

const ModalBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
`;

const CloseButton = styled.div`
  cursor: pointer;
  color: #faf6e9;
  font-size: 20px;
`;

const HistoryBox = styled.div`
  background: white;
  border: 1px solid ${COLOR_GRAY};
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 10px;
`;

const HistoryHeader = styled.div`
  background: ${COLOR_GRAY};
  color: #faf6e9;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 6px 6px 0 0;
`;

const ReservationHistory = ({
  reservationHistory,
  timezone,
  all_tables,
  zones_with_id,
}) => {
  const [showModal, setShowModal] = useState(false);

  const formatInTimeZone = (dateString, timeZone, fmt = "dd-MM HH:mm") => {
    if (!dateString) return "Data inválida";
    try {
      const date = new Date(dateString);
      const zonedDate = utcToZonedTime(date, timeZone);
      return format(zonedDate, fmt, { timeZone });
    } catch {
      return "Data inválida";
    }
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faNewspaper}
        style={{
          color: "#FAF6E9",
          fontSize: "26px",
          cursor: "pointer",
        }}
        onClick={() => setShowModal(true)}
      />

      {showModal && (
        <Modal>
          <ModalHeader>
            Registo de atividade
            <CloseButton onClick={() => setShowModal(false)}>
              <FontAwesomeIcon icon={faXmark} />
            </CloseButton>
          </ModalHeader>

          <ModalBody>
            {reservationHistory.map((reservation, index) => {
              const previousReservation =
                index + 1 > 0 ? reservationHistory[index + 1] : null;
              return (
                <HistoryBox key={reservation.history_id}>
                  <HistoryHeader>
                    <Row>
                      <Col xs={4}>
                        Atualização #{reservationHistory.length - index}
                      </Col>
                      <Col xs={4} style={{ textTransform: "capitalize" }}>
                        {reservation.changes_made_by?.toLowerCase() === "system"
                          ? "Restaurante"
                          : reservation.changes_made_by?.toLowerCase() ===
                            "customer"
                          ? "Cliente"
                          : reservation.changes_made_by}
                      </Col>
                      <Col xs={4}>
                        <DefaultDateSmallMins date={reservation.history_date} />
                      </Col>
                    </Row>
                  </HistoryHeader>

                  <div style={{ padding: "8px 4px" }}>
                    <ReservationItems
                      previousReservationFromHistory={previousReservation}
                      reservation={reservation}
                      all_tables={all_tables}
                      isReservationHistory={true}
                    />
                  </div>
                </HistoryBox>
              );
            })}
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default ReservationHistory;
